<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      selected-product="cso"
      :product-options="productOptions"
      :filter-names="filterNames"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:charge_point_id="{ item }">
        <div class="d-flex align-center">
          <StatusBadge :status="item.connectivity_status" />
          {{ item.charge_point_id }}
        </div>
      </template>
      <template v-slot:manufacturer="{ item }">
        <div>
          {{ item.manufacturer + " - " + item.model }}
        </div>
      </template>
      <template v-slot:updated_at="{ item }">
        <div>
          {{ item.updated_at | formatDate }}
        </div>
      </template>
      <template v-slot:is_private="{ item }">
        <div>
          {{ item.is_private == 0 ? "Public" : "Private" }}
        </div>
      </template>

      <template v-slot:type="{ item }">
        <div>
          {{ item.type ? item.type : "N/A" }}
        </div>
      </template>
      <template v-slot:actions="{ item }">
        <v-icon
          class="mr-2"
          small
          @click="openOcppModal(item)"
        >
          mdi-information
        </v-icon>
        <!-- <v-icon
          v-if="isView"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-eye
        </v-icon> -->
        <!-- <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon> -->
        <!-- <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon> -->
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">

        </v-card>
      </template> -->
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <!-- <template #actionModals>
        <div></div>
      </template> -->
      <!-- Action Modals -->
    </ListingLayout>
    <Modal
      v-if="ocppIdModal"
      title=""
      :is-visible="ocppIdModal"
      :loading="isOcppLoading"
      width="80%"
      :on-save="onSave"
      :toggle="() => (ocppIdModal = false)"
    >
      <div>
        <div class="py-2 d-flex justify-space-between">
          <h2 class="">
            OCPP Configuration: {{ selectedChargePointID }}
          </h2>
          <div
            class="cursor-pointer"
            @click="ocppIdModal = false"
          >
            <v-icon>mdi-close</v-icon>
          </div>
        </div>
        <v-divider />
        <div
          v-if="isOcppLoading"
          class="loading"
        />
        <v-row
          v-else
          class="mt-3"
        >
          <v-col
            v-for="(st, i) in ocppData"
            :key="i"
            md="6"
            col="12"
          >
            <div>
              <!-- {{ st }} -->
              <label :for="st.key">{{ st?.key }}</label>
              <div>
                <v-switch
                  v-if="['true', 'false'].includes(st.value)"
                  :value="st.value"
                  :disabled="st.readonly"
                  @change="
                    (v) => onConfigChange(st, v == 'false' ? 'true' : 'false')
                  "
                />
                <v-text-field
                  v-else
                  type="text"
                  :value="st.value"
                  :disabled="st.readonly"
                  outlined
                  @change="(v) => onConfigChange(st, v)"
                />
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </Modal>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    Modal: () => import("@/components/Modals/Modal.vue"),
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      permissions: {
        view: "config-management.view",
        create: "config-management.create",
        edit: "config-management.edit",
        delete: "config-management.delete",
      },
      action: "remote-change-configuration",

      ocppIdModal: false,
      isOcppLoading: false,
      selectedChargePointID: null,
      ocppData: [],
      //
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      filters: {},
      subFilters: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "csmsChargeStations/getLoading",
      meta: "csmsChargeStations/getMeta",
      list: "csmsChargeStations/getList",
    }),
    _headers() {
      const headers = [
        // {
        //   text: this.$t("id"),
        //   align: "left",
        //   sortable: true,
        //   value: "id",
        // },
        {
          text: this.$t("charge_point_id"),
          align: "left",
          sortable: false,
          value: "charge_point_id",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        {
          text: this.$t("manufacturer"),
          align: "left",
          sortable: false,
          value: "manufacturer",
        },
        ...(this.authUser.user_nature == "fleet"
          ? [
              {
                text: this.$t("manufacturer"),
                align: "left",
                sortable: false,
                value: "tenant_name",
              },
            ]
          : []),
        {
          text: this.$t("location"),
          align: "left",
          sortable: false,
          value: "location_name",
        },
        // {
        //   text: this.$t("station_type"),
        //   align: "left",
        //   sortable: false,
        //   value: "station_type",
        // },
        {
          text: this.$t("connectors"),
          align: "center",
          sortable: false,
          value: "charger_connectors_count",
        },
        {
          text: this.$t("power_type"),
          align: "center",
          sortable: false,
          value: "type",
        },
        {
          text: this.$t("access_level"),
          align: "left",
          sortable: false,
          value: "is_private",
        },
        {
          text: this.$t("status"),
          align: "left",
          sortable: false,
          value: "charge_station_status",
        },
        {
          text: this.$t("last_heartbeat_received"),
          align: "left",
          sortable: false,
          value: "last_heartbeat_received",
        },
        {
          text: this.$t("actions"),
          align: "left",
          sortable: false,
          value: "actions",
        },
        // ...(this.isView || this.isEdit || this.isDelete
        //   ? [
        //       {
        //         text: this.$t("actions"),
        //         align: "left",
        //         sortable: false,
        //         value: "actions",
        //       },
        //     ]
        //   : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["search", "locations", "charge_point"];
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {},
  beforeDestroy() {
    const params = {
      name: "config_management",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options };
      await this.$store.dispatch("csmsChargeStations/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    },

    async openOcppModal(item) {
      this.selectedChargePointID = item?.charge_point_id;
      this.ocppData = [];
      this.isOcppLoading = true;
      this.ocppIdModal = true;

      const params = {
        action: "remote-get-configuration",
        charge_point_id: item?.charge_point_id,
      };
      await this.$store
        .dispatch("csmsChargeStations/ocppRemoteAction", params)
        .then((res) => {
          this.ocppData = res?.body?.status;
        })
        .catch(() => (this.ocppIdModal = false))
        .finally(() => (this.isOcppLoading = false));
    },

    async onSave() {
      const params = this.ocppData
        .filter((r) => r.action)
        .map((r) => ({ ...r, charge_point_id: this.selectedChargePointID }));
      //
      this.isOcppLoading = true;
      await this.$store
        .dispatch("csmsChargeStations/ocppRemoteAction", params)
        .then(() => {
          this.$store.dispatch(
            "alerts/success",
            this.$t("updated_successfully")
          );
          this.ocppIdModal = true;
        })
        .finally(() => (this.isOcppLoading = false));
    },

    onConfigChange(st, v) {
      st.value = v;
      // $set makes the new "action" key reactive in Vue 2
      this.$set(st, "action", this.action); // "remote-change-configuration"
    },
  },
};
</script>
<style scoped>
.row-box-wrap {
  display: flex;
  align-items: center;
  margin: 8px 0;
  gap: 10px;
  /* Adds space between items */
}

.text-muted {
  color: #6c757d;
}

.highlighted {
  font-weight: bold;
}

.copy-button {
  margin-left: auto;
  /* Pushes the button to the far right */
}
</style>
